import { createI18n, type I18n } from "vue-i18n";
import { DEFAULT_LOCALE } from "@/utils/constants";
import en from "@/locales/en.json";

export let i18n: I18n;

export const initializeTranslations = async () => {
  // @ts-ignore
  i18n = createI18n({
    legacy: false,
    locale: DEFAULT_LOCALE, // set locale
    fallbackLocale: DEFAULT_LOCALE,
    messages: { [DEFAULT_LOCALE]: en }, // set locale messages
  });
  return i18n;
};
